import ApiService from "../base/api_service"

export const updateProcurementItem = async (accessToken, formData, id) => {
    try {
        const response = await ApiService.post(`/procurement-item/update/${id}`, formData, {
            headers: {
                Authorization: accessToken,
                'Content-Type': 'application/json'
            }
        })

        return response
    } catch (error) {
        return error.response
    }
}